import all from './all';
import list from './list';
import orders from './orders';

const module = {
  namespaced: true,
  modules: {
    all,
    list,
    orders,
  },
};

export default module;
